import {
  CLEAR_DASHBOARD,
  FETCH_DASHBOARD_SUCCESS
} from '../../../actions/pages/dashboard-page'

export function dashboardPage(
  state = {
    dashboard: null
  },
  action
) {
  switch (action.type) {
    case CLEAR_DASHBOARD: {
      return Object.assign({}, state, {
        dashboard: null
      })
    }
    case FETCH_DASHBOARD_SUCCESS: {
      return Object.assign({}, state, {
        dashboard: action.dashboard
      })
    }
    default:
      return state
  }
}
